<template>
  <v-layout>
    <v-flex xs12>
      <v-card class="loginArea">
        <v-system-bar color="primary" dark>
          <v-spacer></v-spacer>
          <v-icon
            v-show="confirmEmail"
            style="cursor: pointer"
            @click="resetLoginFrm"
            >cached</v-icon
          >
        </v-system-bar>
        <v-img
          :src="logo.src"
          class="white--text mx-5 mt-2"
          height="auto"
          :alt="logo.title"
        />
        <v-card-title class="justify-center" v-if="!clientList">
          <p color="primary" class="mt-2 mb-0" data-i18n="">
            {{ logo.recoverPwd }}
          </p>
          <p class="mt-0 mb-0 text-center subheading" data-i18n="">
            {{ logo.recoverPwdTxt }}
          </p>
        </v-card-title>
        <v-card-title class="justify-start" v-if="clientList">
          <p
            color="primary"
            class="mt-2 mb-1 mx-2 subheading font-weight-bold text-xs-left"
          >
            Você possui mais de uma conta
          </p>
          <p class="mt-0 mb-1 mx-2 text-xs-left body-2" data-i18n>
            Selecione na lista abaixo a conta que deseja acessar.
          </p>
        </v-card-title>
        <div v-if="clientList">
          <v-data-table
            hide-actions
            :headers="[]"
            hide-headers
            :items="accounts"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td
                style="cursor: pointer"
                @click="selectCompany(props.item.id)"
                class="text-xs-left"
              >
                <b style="display: block">{{ props.item.name }}</b
                ><span>{{ props.item.document | formatCnpjCpf }}</span>
              </td>
            </template>
          </v-data-table>
        </div>
        <v-card-text v-if="!confirmEmail">
          <v-form ref="resetPwdForm" v-model="validForm">
            <v-text-field
              v-model="formData.email"
              prepend-icon="person"
              label="E-mail"
              type="email"
              :rules="$store.state.formRules.emailRules"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions class="text-center pr-3 pl-3 pb-3">
          <v-btn flat color="grey darken-2" to="/login" v-if="!confirmEmail"
            >login</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            @click="resetLoginFrm"
            v-if="clientList"
            flat
            color="grey darken-2"
            >VOLTAR</v-btn
          >
          <v-btn
            v-if="!confirmEmail"
            :loading="loadingBt"
            :disabled="loadingBt"
            color="primary"
            class="white--text"
            @click="verifyUserMail"
            @keydown:enter="verifyUserMail"
            >Solicitar nova senha</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    errors: String
  },

  data () {
    return {
      logo: {
        recoverPwd: 'Recuperar senha',
        recoverPwdTxt:
          'O sistema irá enviar nova senha temporária para o endereço de email cadastrado.',
        restrictedarea: 'Área restrita',
        src: './img/logo.png',
        title: 'InSight Síndicos',
        txt: 'Faça login para acessar o sistema.'
      },
      loadingBt: false,
      clientList: false,
      accounts: [],
      confirmEmail: false,
      setPass: false,
      formData: {
        user_id: '',
        email: null
      },
      validForm: true
    }
  },

  mounted () {
    if (this.errors) {
      let opts = {
        message: this.errors,
        type: 'error'
      }
      this.$store.commit('showAlert', opts)
    }
  },

  methods: {
    resetLoginFrm () {
      this.accounts = []
      this.setPass = false
      this.clientList = false
      this.confirmEmail = false
      this.formData.user_id = ''
    },

    selectCompany (id) {
      this.formData.user_id = id
      this.resetPassword()
    },

    verifyUserMail (e) {
      // if (this.formData.user_id) {
      //   this.resetPassword();
      //   return;
      // }
      console.log(e)
      // if (e) {
      //   alert(event.target.tagName)
      // }
      this.loadingBt = true
      let obj = {
        url: '/api/user/clients',
        query: this.formData,
        method: 'post',
        noLoader: true
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        this.loadingBt = false
        if (!response) {
          return
        }
        if (response.data.length < 1) {
          let opts = {
            message: 'Usuário não encontrado.',
            type: 'warning'
          }
          this.$store.commit('showAlert', opts)
          return
        }
        if (response.data.length > 1) {
          // this.$router.push("/recuperarsenha");
          this.accounts = [...response.data]
          this.confirmEmail = true
          this.clientList = true
        } else {
          this.formData.user_id = response.data[0].id
          this.resetPassword()
        }
        console.log(response.data)
      })
    },

    resetPassword () {
      let _this = this
      // console.log("/////");
      if (this.formData.email) {
        let obj = {
          url: '/api/reset/password',
          query: this.formData,
          method: 'post'
        }
        this.$store.dispatch('request/doRequest', obj).then((response) => {
          if (response) {
            _this.$router.push('/login')
          }
          this.resetLoginFrm()
        })
      }
    }
  },

  filters: {
    formatCnpjCpf (value) {
      if (value.length > 11) {
        value = value.replace(
          /^([0-9]{2})([0-9]{3})([0-9]{3})([0-9]{4})([0-9]{2})$/,
          '$1.$2.$3/$4-$5'
        )
      } else {
        value = value.replace(
          /^([0-9]{3})([0-9]{3})([0-9]{3})([0-9]{2})$/,
          '$1.$2.$3-$4'
        )
      }
      return value
    }
  }
}
</script>

<style>
.loginArea {
  max-width: 350px;
  margin: auto;
}
</style>
